export const STATUS_OBJ = {
  Analysis: 'Em Análise',
  Pendent: 'Pendência',
  Credit: 'Crédito',
  Compensated: 'Indenizado',
  Closed: 'Encerrado',
  Draft: 'Rascunho',
  AnalysisPP: 'Em Análise - PP', // PP = Pagamento parcial
  PendentPP: 'Pendência - PP',
  CreditPP: 'Crédito - PP',
  CompensatedPP: 'Pago Parcial',
};

export const STATUS_BROKER = {
  pendent: 'Pendência',
  indemnified: 'Indenizado',
  closed: 'Encerrado',
  pendingInsured: 'Pendência Segurado',
  pendingInsurance: 'Pendência Seguradora',
  pendingRegulatory: 'Pendência Reguladora',
  pendingInsuredAgreement: 'Pendência de Acordo Segurado',
  pendingPayment: 'Pendência de Pagamento',
  pendingAgreement: 'Pendência de Acordo',
  indemnifiedPP: 'Pago Parcial',
};

export const STEPS_STATUS = {
  CommunicationDate: 'Data de comunicação',
  Documentation: 'Documentação',
  SuccessLossCalculation: 'Apuração de prejuízo aprovada',
  SignedTerm: 'Termo assinado',

  DocumentsSent: 'Documentos enviados',
  CreditSchedule: 'Programação de credito',
  FailedLossCalculation: 'Apuração de prejuízo reprovada',

  AdministrativeClosure: 'Carta de encerramento administrativo',
  InvalidInformations: 'Informações invalidas',
  NegativeLetter: 'Carta negativa',

  DocumentRequest: 'Solicitações de documentos',
  LossCalculation: 'Apuração de prejuízo',
  DischargeTerms: 'Termos de quitação',

  FullIndemnity: 'Indenização total',
  PartialIndemnity: 'Indenização parcial',
};

export const BROKER_ACTIONS = {
  Open: 'ABERTURA',
  InsurancePendency: 'PENDENCIA SEGURADORA',
  FranchiseePendency: 'PENDENCIA SEGURADO',
  RegulatorPendency: 'PENDENTE REGULADORA',
  FollowupDocsFranchisee: 'FOLLOW-UP DOCS SEGURADO',
  FranchiseeAgreementPendency: 'PENDENTE DE ACORDO SEGURADO',
  CanceledClaim: 'SINISTRO CANCELADO - ERRO DE CADASTRO',
  RefusedClaim: 'PROCESSO RECUSADO',
  ReanalysisRequest: 'SOLICITACAO DE REANALISE',
  AgreementPayment: 'PENDENTE DO DE ACORDO',
  PendingPayment: 'PENDENTE PAGAMENTO',
  PaidProcess: 'PROCESSO PAGO',
  AdministrativeClosed: 'PROCESSO ENCERRADO SEM INDENIZACAO',
  InsurancePendencyPP: 'PENDENCIA SEGURADORA - PP', // PP = Pagamento parcial
  FranchiseePendencyPP: 'PENDENCIA SEGURADO - PP',
  RegulatorPendencyPP: 'PENDENTE REGULADORA - PP',
  FollowupDocsFranchiseePP: 'FOLLOW-UP DOCS SEGURADO - PP',
  FranchiseeAgreementPendencyPP: 'PENDENTE DE ACORDO SEGURADO - PP',
  CanceledClaimPP: 'SINISTRO CANCELADO - ERRO DE CADASTRO - PP',
  RefusedClaimPP: 'PROCESSO RECUSADO - PP',
  ReanalysisRequestPP: 'SOLICITACAO DE REANALISE - PP',
  AgreementPaymentPP: 'PENDENTE DO DE ACORDO - PP',
  PendingPaymentPP: 'PENDENTE PAGAMENTO - PP',
  PaidProcessPP: 'PROCESSO PAGO - PP',
  AdministrativeClosedPP: 'PROCESSO ENCERRADO SEM INDENIZACAO - PP',
};

export const DAYS_OBJ = {
  ninetyDaysOrMore: '+90 dias',
  thirtyDaysOrMore: '+30 dias',
  sixtyDaysOrMore: '+60 dias',
  hundredTwentyDaysOrMore: '+120 dias',
};
